import $ from 'jquery'

export default class TopLevelConfigurator {
  $wrapper

  constructor($wrapper) {
    this.$wrapper = $wrapper
    this.$wrapper.find('.tl-configurator__choice').click((e) => this.onClick(e))
  }

  onClick(e) {
    const $choice = $(e.currentTarget)
    const $link = $choice.find(
      '> .tl-configurator__container a.tl-configurator__button',
    )

    e.preventDefault()
    e.stopPropagation()

    if ($link.length > 0) {
      window.location = $link.attr('href')

      return
    }

    const isActive = $choice.hasClass('tl-configurator__choice--active')

    $choice
      .find('.tl-configurator__choice--active')
      .removeClass('tl-configurator__choice--active')
      .end()
      .toggleClass('tl-configurator__choice--active', !isActive)
      .find('> .tl-configurator__children')
      .toggle(!isActive)
      .end()
      .siblings('.tl-configurator__choice')
      .toggle(isActive)
      .end()
      .find('.tl-configurator__button')
      .text('Weiter')
      .end()
      .find('> .tl-configurator__container .tl-configurator__button')
      .text(isActive ? 'Weiter' : 'Zurück')
  }
}
